<ng-container *ngIf="event$ | async as event; else loading">
  <div class="image-banner image-banner--shadow">
    <div class="banner-bg banner-bg--blurred" [ngStyle]="{ 'backgroundImage': 'url(' + (event?.images?.length ? (event?.images[0] | s3Img:'events':100) : event?.entity?.images?.length ? (event?.entity?.images[0] | s3Img:'entities':100) : fallbackImageBlurred) + ')' }"></div>
    <div class="banner-bg" [ngStyle]="{ 'backgroundImage': 'url(' + (event?.images?.length ? (event?.images[0] | s3Img:'events':deviceWidth || 1800) : event?.entity?.images?.length ? (event?.entity?.images[0] | s3Img:'entities':deviceWidth || 1800) : fallbackImage) + ')' }"></div>
    <div class="overlay d-flex align-items-center justify-content-center flex-column">
      <app-store-icons class="mb-2" page="Event-Banner"></app-store-icons>
      <h1 class="text-center mb-0">
        {{ event?.title }}
      </h1>
      <p class="black-box mt-2">
        <ng-container *ngIf="event.startDate; else repeatEventDates">
          <span [innerHTML]="event.startDate | twoDatesDisplay: event.endDate:true"></span>
          </ng-container>
          <ng-template #repeatEventDates>
              {{ event.daysOfWeek && event.daysOfWeek[0] !== 7 ? 'Every' : '' }} {{ event.daysOfWeek | daysOfWeek }}
              {{ event.startTime }} - {{ event.endTime }}
          </ng-template>
        </p>
    </div>
  </div>
  <div class="page-content">
    <section class="w-100 bg-light py-0">
      <div class="container">
        <div class="d-flex flex-center flex-column" [ngClass]="{'pt-4': !event.entity}">
            <ng-container *ngIf="event.entity || event.publisher || event.logo">
              <div class="logo rounded-circle mx-auto">
                <img-fade [animate]="true" [src]="logoPrefix + (event.logo ? event.logo : event.ownerType === 'PROMOTER' ? event.publisher?.logo || event.entity?.logo : event.entity?.logo || event.publisher?.logo)" [alt]="event?.title + ' logo'"></img-fade>
              </div>
              <!-- <p class="h2 my-2 text-center text-medium  font-weight-bold">
                {{ event.entity?.title }} <br />
              </p> -->
            </ng-container>
            <!-- <p *ngIf="event?.categories?.length" class="mb-1 text-uppercase">
              <ng-container *ngFor="let cat of event?.categories; let ic = index;">
                {{ ic === 0 ? '•' : '' }} {{ cat }} •
              </ng-container>
            </p> -->
            <!-- <p *ngIf="event?.address?.title || event?.city || event?.entity?.title"  class="h5 my-0 text-center text-medium font-weight-bold">
              {{ event?.city || event?.address?.title || event?.entity?.title }}
            </p> -->
        </div>
        <div class="container pb-3 pb-sm-4">
          <div class="d-flex flex-column flex-center mb-3">
            <div class="mt-2 mb-3 text-center">
              <ng-container *ngIf="event?.entity; else cityName">
                <a class="link font-weight-bold d-flex flex-center cursor-pointer" [routerLink]="event.entity.username ? ['/places', 'place', event.entity.username] : ['/places', event.entity.id]">
                  {{ event?.entity?.title }}
                  <fa-icon [icon]="faChevronRight" class="ml-1 chevron" [style.color]="primaryColourText || ''"></fa-icon>
                </a>
              </ng-container>
              <ng-template #cityName>
                <span class="font-weight-bold">
                  {{event?.address?.title || event?.city}}<br/>
                </span>
              </ng-template>
              <!-- <p class="mb-0 font-weight-bold" *ngIf="event?.address?.title;" >{{ event?.address?.title }}</p> -->
              <p class="font-weight-bold mb-0" *ngIf="!event?.address && !event?.entity; else eventFullAddress" >Location TBA</p>
              <ng-template #eventFullAddress>
                <a class="text-medium mb-0 small" [href]="'https://www.google.com/maps/search/?api=1&query=' + (event | formatAddress: true)" target="_blank">
                  {{ event | formatAddress: true }}
                </a>
              </ng-template>
            </div>
            <a class="btn btn-primary w-100 btn--shadow" *ngIf="event?.buyTicketUrl" [href]="event?.buyTicketUrl"
              target="_blank">
              Buy Tickets
            </a>
            <a class="btn btn-primary w-100 btn--shadow"
            [href]="'https://bookings.ping-culture.com/ticket?event_id=' + event?.id + '&type=' + event.type" target="_blank" *ngIf="event?.config?.canBuyTickets">
              Ping Tickets
            </a>

            <!-- <a class="btn btn-primary w-100 btn--shadow"
            id="PingCultureTicketsModalBtn" data-event="{{ event?.id }}" (click)="openTicketWidgetModal(event)" *ngIf="event?.config?.canBuyTickets">
              Ping Tickets
            </a> -->
            <a class="btn btn-primary w-100 btn--shadow mt-2" *ngIf="event?.tables?.items?.length && (!event?.buyTicketUrl && !event?.config?.canBuyTickets)"
              pingOpenDownloadModal>
              Book a Table
            </a>
          </div>
        </div>
      </div>
    </section>




    <section class="w-100" *ngIf="event?.description && event?.description !== ''">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <h2 class="info-title mb-3">About</h2>
          </div>
          <div class="col-12 col-md-8">
            <read-more [content]="event.description" [limit]="300"></read-more>
          </div>
        </div>
      </div>
    </section>




    <section class="w-100" *ngIf="event?.entity">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4">
            <h2 class="info-title mb-3">Venue</h2>
          </div>
          <div class="col-12 col-md-8">

            <ping-place-card [place]="event.entity"></ping-place-card>

          </div>
        </div>
      </div>
    </section>


    <section class="w-100" *ngIf="event?.timelines && event?.timelines?.length">
      <div class="container">
        <ng-container *ngIf="event.timelines">
          <div class="row" *ngIf="event?.timelines?.length === 1">
            <div class="col-12 col-md-4">
              <h2 class="info-title">Schedule</h2>
            </div>
            <div class="col-12 pb-0 pb-md-5 col-md-8 content-box">
              <div class="row">
                <div class="col-12 col-sm-6" *ngFor="let i of event.timelines[0].timeslots">
                  <ping-timeline-slot [item]="i" [hideImage]="noTimelineImages"></ping-timeline-slot>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="event?.timelines?.length > 1">
            <div class="col-12 col-md-4">
              <h2 class="info-title">Schedules</h2>
              <div class="d-flex flex-row flex-md-column">
                <a (click)="setTimeline(t)" class="timeline-link py-2" *ngFor="let t of event.timelines" [ngClass]="{ 'text-primary font-weight-bold' : currentTimeline?.title === t?.title }">{{ t?.title }}</a>

              </div>
            </div>
            <div class="col-12 col-md-8 content-box">
              <div class="row">
                <div class="col-12 col-sm-6" *ngFor="let i of currentTimeline?.timeslots">
                  <ping-timeline-slot [item]="i"></ping-timeline-slot>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </section>

      <section
      *ngIf="event.eventFeatures?.length">
        <div class="container">
          <div class="row row--fullwidth">
            <div class="col-12 col-md-4">
              <h2 class="info-title">Features</h2>
            </div>
            <div class="col-sm-8 content-box side-scroller p-0">
              <div class="row row--fullwidth d-flex flex-nowrap">
                <div class="px-0" *ngFor="let feature of event.eventFeatures" [ngClass]="{'col-8' : event.eventFeatures?.length > 1, 'col-12' : event.eventFeatures?.length < 2}">
                  <ping-feature-card [feature]="feature" [parent]="event" parentImgPrefix="events"></ping-feature-card>
                </div>
                <!-- <div class="col-12 col-md-4 text-center d-flex flex-center">
                    <button mat-stroked-button color="primary">View more
                      <fa-icon [icon]="faChevronRight" class="ml-1"></fa-icon>
                    </button>
                  </div> -->
              </div>
            </div>
          </div>
        </div>
      </section>



      <section id="menu" #menu [style.border-color]="colourScheme?.primary"
        *ngIf="event?.menuUrlList?.length || event?.menuImages?.length || event.menu || event.menuPDFList?.length">
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-4">
              <h2 class="info-title">{{ event.menu ? (event.menu.title | titlecase)
                : 'Menus' }}</h2>
            </div>
            <div class="col-12 col-md-8 content-box side-scroller" *ngIf="event?.menuImages?.length || event.menu">
              <ng-container *ngIf="event?.menuImages?.length">
                <div class="d-flex row row--fullwidth flex-nowrap">
                  <div class="menu-img border preview-img d-flex flex-center col-8 col-sm-5 px-0 mx-3 "
                    *ngFor="let img of event.menuImages; let i = index">
                    <img [src]="img | s3Img:'menu':300:false: 700"
                      alt="Menu {{ i + 1}} from {{ event?.title}}'s menu images'" />
                    <div class="overlay d-flex flex-center" pingGallery [images]="event.menuImages" [imagesPrefix]="'menu'"
                      [currentIndex]="i">
                      <fa-icon [icon]="faEye" size="3x" [ngClass]="{'text-light' : !colourScheme?.text }"
                      ></fa-icon>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ping-menu *ngIf="event.menu" [entity]="event" [menu]="event?.menu" [colourScheme]="colourScheme"></ping-menu>
            </div>
            <div class="col-12 col-md-8 content-box p-3 d-flex " *ngIf="event?.menuUrlList?.length">
              <div *ngIf="event?.menuUrlList?.length" class="row w-100">
                <div class="col-12 col-sm-6 my-2" *ngFor="let url of event.menuUrlList">
                  <a class="card border-radius d-flex align-items-center justify-content-between flex-row p-4 link"
                  [style.border-color]="secondaryColourText || ''"
                  [style.background]="colourScheme?.secondary || ''"
                  [style.color]="secondaryColourText || ''"
                    [href]="url.url" target="_blank"
                    >
                    <div class="d-flex align-items-center">
                      <!-- <fa-icon [icon]="faBook" class="text-primary mr-3" size="2x"></fa-icon> -->
                      <p class="m-0 font-weight-bold" [style.color]="secondaryColourText || ''">
                        {{ url.title }}
                      </p>
                    </div>
                    <fa-icon [icon]="faChevronRight" [style.color]="secondaryColourText || ''"></fa-icon>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-8 content-box p-3 d-flex " *ngIf="event?.menuPDFList?.length">
              <div *ngIf="event?.menuPDFList?.length" class="row w-100">
                <div class="col-12 col-sm-6 my-2" *ngFor="let url of event.menuPDFList">
                  <a class="card border-radius d-flex align-items-center justify-content-between flex-row p-4 link"
                    [href]="pdfMenuPrefix + url.url" target="_blank"
                    >
                    <div class="d-flex align-items-center">
                      <!-- <fa-icon [icon]="faBook" class="text-primary mr-3" size="2x"></fa-icon> -->
                      <p class="m-0 font-weight-bold">
                        {{ url.title }}
                      </p>
                    </div>
                    <fa-icon [icon]="faChevronRight"></fa-icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="p-0" *ngIf="event?.entity?.images?.length || (event.images?.length > 1)" style="position: relative;">
        <div class="gallery__title" *ngIf="event?.entity?.images?.length">Event &amp; Venue</div>
        <div class="w-100 gallery">
          <div class="d-flex flex-grow-1 align-items-center">
            <ng-container *ngIf="event?.images?.length">
              <div class="gallery-img preview-img d-flex" *ngFor="let img of event.images; let i = index" [ngClas]="{'gallery-img--half': (event.images?.length === 2 && !event?.entity?.images?.length) || (event?.images?.length === 1 && event?.entity?.images?.length === 1) }">
                <img [src]="img | s3Img:'events':700:false: 500" alt="Image {{ i + 1}} from {{ event?.title}}'s image gallery'" />
                <div class="overlay d-flex flex-center" pingGallery [images]="event.images" [imagesPrefix]="'events'"
                  [currentIndex]="i">

                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="event?.entity?.images?.length">
              <div class="gallery-img preview-img d-flex" *ngFor="let img of event.entity.images; let i = index">
                <img [src]="img | s3Img:'entities':700:false: 500" alt="Image {{ i + 1}} from {{ event?.entity?.title}}'s image gallery'" />
                <div class="overlay d-flex flex-center" pingGallery [images]="event.entity.images" [imagesPrefix]="'entities'"
                  [currentIndex]="i">

                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </section>

      <ping-video-embed *ngIf="event?.video" [url]="event.video"></ping-video-embed>

      <section *ngIf="event.checklist?.listItems?.length">
        <div class="container">
          <section class="row">
            <div class="col-12 col-md-4">
              <h2 class="info-title">{{ event.checklist?.title }}</h2>
            </div>
            <div class="col-12 col-md-8">
              <p class="text-medium checklist-item mb-3" style="font-size: 1.2rem;" *ngFor="let item of event.checklist?.listItems">
                <span class="pl-4">
                  {{ item }}
                </span>
              </p>
            </div>
          </section>
        </div>
      </section>

      <section class="w-100"  *ngIf="event?.extraInfo && event?.extraInfo?.length">
        <div class="container">
          <ping-additional-info [extraArray]="event.extraInfo"></ping-additional-info>
        </div>
      </section>

          <section
          *ngIf="event?.ownerType === 'PROMOTER'">
            <div class="container">
              <div class="row row--fullwidth">
                <div class="col-12 col-md-4">
                  <h2 class="info-title">Organizer</h2>
                </div>
                <div class="col-12 col-md-8 py-3 py-sm-0 d-flex w-100 flex-column">
                  <a class="w-100 d-flex align-items-center" [routerLink]="event.ownerType === 'PROMOTER' ? ['/promoter', event.publisherId] : ['/places', event.entity?.id]">
                    <div class="logo-small mr-4 border" *ngIf="event?.publisher?.logo">
                      <img-fade [animate]="true" [src]="logoPrefix + (event.ownerType === 'PROMOTER' ? event.publisher?.logo || event.entity?.logo : event.entity?.logo || event.publisher?.logo)" [alt]="event?.title + ' logo'"></img-fade>
                    </div>

                    <div class="d-flex flex-column">
                      <p class="h4">
                        {{ event?.ownerType === 'PROMOTER' ? event?.publisher?.businessName : event?.entity?.title}}
                      </p>
                      <p>
                        <span *ngIf="event?.ownerType === 'PROMOTER'">
                          <a [routerLink]="['/promoter', event.publisherId]" class="link d-flex align-items-center">
                            See their events
                            <fa-icon [icon]="faChevronRight" class="ml-2"></fa-icon>
                          </a>
                        </span>
                        <span *ngIf="event?.ownerType !== 'PROMOTER'">
                          <p class="text-medium mb-2"><small>{{ event.entity?.address?.city }}, {{ event.entity?.address?.postcode }} </small></p>
                          <a mat-stroked-button color="primary" [routerLink]="['/places', event.entity?.id]" class="link">
                            See this place
                            <fa-icon [icon]="faChevronRight" class="ml-2"></fa-icon>
                          </a>
                        </span>
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>

      <section class="w-100" *ngIf="event.features?.length || event.entity?.features?.length">
        <div class="container">
          <section class="row">
            <div class="col-12 col-md-4">
              <h2 class="info-title">Facilities</h2>
            </div>
            <div class="col-12 col-md-8">
              <facilities [list]="event.features || event.entity?.features" class="row w-100"></facilities>
            </div>
          </section>
        </div>
      </section>


      <section
      *ngIf="event?.entity?.nearbyStations?.length">
        <div class="container">
          <div class="row row--fullwidth">
            <div class="col-12 col-md-4">
              <h2 class="info-title">Nearest Stations</h2>
            </div>
            <div class="col-12 col-md-8 py-3 py-sm-0 d-flex w-100 flex-column  equal-icons">
              <a *ngFor="let station of event?.entity?.nearbyStations" class="mb-3 d-flex align-items-center" target="_blank" [href]="'https://www.google.com/maps/search/?api=1&query=' + station.title">
              <fa-icon *ngIf="station.type === 'train_station'" [icon]="faSubway" class="mr-3 text-medium" size="2x"></fa-icon>
              <fa-icon *ngIf="station.type === 'bus_stop'" [icon]="faBus" class="mr-3 text-medium" size="2x"></fa-icon>
                <fa-icon *ngIf="station.type === 'tube_station'" [icon]="faTrain" class="mr-3 text-medium" size="2x"></fa-icon>
                <p class="mb-0" [style.color]="colourScheme?.text || ''">{{ station?.title }}
                  <span class="badge badge-secondary" slot="end" *ngIf="station?.distance">{{ station.distance | number:'1.0-0'}}m</span>
                </p>
              </a>
            </div>
          </div>
        </div>
      </section>


      <section class="w-100 py-0">
        <div class="container">
          <google-map height="300px" class="border-radius" width="100%" [zoom]="zoom"
            [center]="{ lat: event.location.lat, lng: event.location.lon }" [options]="options">
            <map-marker [position]="marker.position" [label]="marker.label" [title]="marker.title" [options]="marker.options">
            </map-marker>
          </google-map>
        </div>
      </section>


      <ng-template #fakeMore>
        <section class="bg-white">
          <div class="container">
            <h2 class="mb-3" >Similar events in this area</h2>
            <ping-download-app-cards [rowAmount]="3" [height]="'10rem'" subText="Sign Up for free to access similar event recommendations" [page]="'Event'"></ping-download-app-cards>
          </div>
        </section>
      </ng-template>

      <ng-container *ngIf="moreEvents$ | async as moreEvents">
        <ng-container *ngIf="moreEvents && moreEvents?.length; else fakeMore">
          <section>
            <div class="container">
              <div class="d-flex justify-content-between align-items-end flex-wrap">
                <h2 class="mb-3">Similar events in this area</h2>
              </div>
              <div class="row position-relative" *ngIf="moreEvents">
                <div class="col-12 col-md-4 my-2 locked-blurred" *ngFor="let event of moreEvents | filterOutAttr:{id: event.id}  | slice: 0:3">
                  <ping-event-card [event]="event"></ping-event-card>
                </div>
                <ping-download-app-locked subText="Sign Up for free to access similar event recommendations" [page]="'Event'"></ping-download-app-locked>
              </div>
            </div>
          </section>
          <section class="pt-0">
            <div class="container container--narrow">
              <!-- DOWNLOAD TOUT -->
              <ping-download-app [curved]="true"></ping-download-app>
            </div>
          </section>
        </ng-container>
      </ng-container>

      <!-- <div class="w-100 bg-light">
        <div class="container--narrow">
          <div class="py-5">
            <ping-subscribe-sendy page="Event"></ping-subscribe-sendy>
          </div>
        </div>

      </div> -->


    </div>
</ng-container>




<ng-template #loading>
  <ngx-skeleton-loader count="1" [theme]="{
      height: '60vh',
      width: '100%',
      'background-color': '#ccc'
    }"></ngx-skeleton-loader>

  <div class="container mt-2">
    <div class="row">
      <div class="col-12">
        <ngx-skeleton-loader count="1" [theme]="{
            height: '9rem',
            width: '90%',
            margin: '3em 0',
            'background-color': '#f1f1f1',
            'border-radius': 0
          }"></ngx-skeleton-loader>
      </div>

    </div>
  </div>
  <div class="container container--narrow">
    <ping-download-app></ping-download-app>
  </div>
</ng-template>

<div class="w-100 bg-light">
  <div class="container">
    <div class="py-5">
      <ping-subscribe-sendy [page]="'Event Page'"></ping-subscribe-sendy>
    </div>
  </div>
</div>
